"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdditionalOptionsAsOps = exports.getSeriesOptionsAsOps = exports.getModelDataAsOps = void 0;
const enums_1 = require("../../../@shared-types/vehicle/enums");
const getHeadline = (title) => [
    { insert: `${title}`, attributes: { bold: true } },
    { insert: '\n' },
];
const getBulletPoint = (text) => [{
        insert: text,
    }, {
        attributes: {
            list: 'bullet',
        },
        insert: '\n',
    }];
const getLinebreak = () => [{ insert: '\n' }];
/** Returns `modelData` of a `AutoboardVehicle` as `Quill` `Delta` `Op`s */
const getModelDataAsOps = (vehicle) => {
    var _a;
    if (!vehicle.modelData)
        return [];
    const ops = [];
    const { assistance, infotainment, safety, comfort, features, } = vehicle.modelData;
    /** Assistance */
    const assistanceOps = [];
    if (assistance.startStop)
        assistanceOps.push(...getBulletPoint('Start-Stopp-System'));
    if (assistance.rainSensor)
        assistanceOps.push(...getBulletPoint('Regensensor'));
    if (assistance.lightSensor)
        assistanceOps.push(...getBulletPoint('Automatisches Abblendlicht'));
    if (assistance.powerSteeting)
        assistanceOps.push(...getBulletPoint('Servolenkung'));
    if (assistance.hillAssist)
        assistanceOps.push(...getBulletPoint('Berganfahrassistent'));
    if (assistance.emergencyCall)
        assistanceOps.push(...getBulletPoint('Notrufsystem'));
    if (assistance.tirePressureMonitoring)
        assistanceOps.push(...getBulletPoint('Reifendruckkontrollsystem'));
    if (assistance.signRecognition)
        assistanceOps.push(...getBulletPoint('Verkehrszeichenerkennung'));
    if (assistance.automaticHighBeam)
        assistanceOps.push(...getBulletPoint('Fernlichtassistent'));
    if (assistance.speedLimiter)
        assistanceOps.push(...getBulletPoint('Geschwindigkeitslimit-Assistent'));
    if (assistance.laneAssistance)
        assistanceOps.push(...getBulletPoint('Spurhalteassistent'));
    if (assistance.blindSpot)
        assistanceOps.push(...getBulletPoint('Totwinkel-Assistent'));
    if (assistance.parking) {
        if (assistance.parking.automaticParking)
            assistanceOps.push(...getBulletPoint('Automatische Einparkhilfe'));
        if (assistance.parking.back)
            assistanceOps.push(...getBulletPoint('Parksensoren hinten'));
        if (assistance.parking.front)
            assistanceOps.push(...getBulletPoint('Parksensoren vorne'));
        if (assistance.parking.rearCamera)
            assistanceOps.push(...getBulletPoint('Rückfahrkamera'));
        if (assistance.parking.surroundCamera)
            assistanceOps.push(...getBulletPoint('360°-Kamera'));
    }
    if (assistance.speedControl === enums_1.ESpeedControl.AdaptiveCruiseControl)
        assistanceOps.push(...getBulletPoint('Adaptiver Tempomat'));
    if (assistance.speedControl === enums_1.ESpeedControl.CruiseControl)
        assistanceOps.push(...getBulletPoint('Tempomat'));
    if (assistanceOps.length) {
        ops.push(...getHeadline('Assistenzsysteme'));
        if (assistanceOps[0].insert) {
            assistanceOps[0].insert = `\n${assistanceOps[0].insert}`;
        }
        ops.push(...assistanceOps);
        ops.push(...getLinebreak());
    }
    /** Infotainment */
    ops.push(...getHeadline('Infotainment'));
    if (infotainment.bluetooth)
        ops.push(...getBulletPoint('Bluetooth'));
    if (infotainment.cd)
        ops.push(...getBulletPoint('CD'));
    if (infotainment.satNav)
        ops.push(...getBulletPoint('Navigationssystem'));
    if (infotainment.boardComputer)
        ops.push(...getBulletPoint('Boardcomputer'));
    if (infotainment.radio === enums_1.ERadio.DAB)
        ops.push(...getBulletPoint('Digitalradio (DAB)'));
    if (infotainment.radio === enums_1.ERadio.DAB_AND_TUNER)
        ops.push(...getBulletPoint('Digitalradio (DAB) & Analoges Radio'));
    if (infotainment.radio === enums_1.ERadio.TUNER)
        ops.push(...getBulletPoint('Analoges Radio'));
    if (infotainment.betterSound)
        ops.push(...getBulletPoint('Besseres Soundsystem'));
    if (infotainment.voiceControl)
        ops.push(...getBulletPoint('Sprachassistent'));
    if (infotainment.touchscreen)
        ops.push(...getBulletPoint('Touchscreen'));
    if (infotainment.usb)
        ops.push(...getBulletPoint('USB'));
    if (infotainment.wifi)
        ops.push(...getBulletPoint('Wi-Fi'));
    if (infotainment.appleCarplay)
        ops.push(...getBulletPoint('Apple CarPlay'));
    if (infotainment.androidAuto)
        ops.push(...getBulletPoint('Android Auto'));
    if (infotainment.digitalDashboard)
        ops.push(...getBulletPoint('Digitaler Tachograph'));
    if (infotainment.wirelessCharging)
        ops.push(...getBulletPoint('Kabelloses Laden für Smartphones'));
    if (infotainment.musicStreaming)
        ops.push(...getBulletPoint('Musikstreamingdienste'));
    if (infotainment.multifunctionSteeringWheel)
        ops.push(...getBulletPoint('Multifuntionslenkrad'));
    if (infotainment.handsFreePhoneSystem)
        ops.push(...getBulletPoint('Freisprecheinrichtung'));
    if (infotainment.tv)
        ops.push(...getBulletPoint('TV'));
    ops.push(...getLinebreak());
    /** Safety */
    ops.push(...getHeadline('Sicherheitsausstattung'));
    if (safety.headlightWasher)
        ops.push(...getBulletPoint('Scheinwerferreinigungsanlage'));
    if (safety.abs)
        ops.push(...getBulletPoint('ABS'));
    if (safety.airbags === enums_1.EAirbags.DRIVER)
        ops.push(...getBulletPoint('Fahrerairbag'));
    if (safety.airbags === enums_1.EAirbags.FRONT)
        ops.push(...getBulletPoint('Frontairbags'));
    if (safety.airbags === enums_1.EAirbags.FRONT_SIDE)
        ops.push(...getBulletPoint('Front- und Seitenairbags'));
    if (safety.airbags === enums_1.EAirbags.FRONT_SIDE_MORE)
        ops.push(...getBulletPoint('Front-, Seiten- und weitere Airbags'));
    if (safety.esp)
        ops.push(...getBulletPoint('ESP'));
    if (safety.frontFogLights)
        ops.push(...getBulletPoint('Nebelscheinwerfer'));
    if (safety.immobilizer)
        ops.push(...getBulletPoint('Elektronische Wegfahrsperre'));
    if (safety.isofixBack)
        ops.push(...getBulletPoint('Isofix-Halterungen Rücksitze'));
    if (safety.isofixPassenger)
        ops.push(...getBulletPoint('Isofix-Halterungen Beifahrersitz'));
    if (safety.daytimeRunningLights === enums_1.EDaytimeRunningLights.NORMAL)
        ops.push(...getBulletPoint('Tagfahrlicht'));
    if (safety.daytimeRunningLights === enums_1.EDaytimeRunningLights.LED)
        ops.push(...getBulletPoint('LED-Tagfahrtlicht'));
    if (safety.specialHeadlightType === enums_1.EHeadlightType.BI_XENON)
        ops.push(...getBulletPoint('Bi-Xenon'));
    if (safety.specialHeadlightType === enums_1.EHeadlightType.LASER)
        ops.push(...getBulletPoint('Laser'));
    if (safety.specialHeadlightType === enums_1.EHeadlightType.LED)
        ops.push(...getBulletPoint('LED'));
    if (safety.specialHeadlightType === enums_1.EHeadlightType.XENON)
        ops.push(...getBulletPoint('Xenon'));
    if (safety.bendingHeadlights === enums_1.EBendingLights.ADAPTIVE)
        ops.push(...getBulletPoint('Adaptives Kurvenlicht'));
    if (safety.bendingHeadlights === enums_1.EBendingLights.BENDING)
        ops.push(...getBulletPoint('Kurvenlicht'));
    if (safety.alarm)
        ops.push(...getBulletPoint('Alarmanlage'));
    if (safety.fatigueWarning)
        ops.push(...getBulletPoint('Aufmerksamkeits-Assistent'));
    if (safety.nightVision)
        ops.push(...getBulletPoint('Nachtsicht-Assistent'));
    if (safety.glareFreeHighBeam)
        ops.push(...getBulletPoint('Blendfreies Fernlicht'));
    if (safety.distanceWarning)
        ops.push(...getBulletPoint('Auffahrwarnsystem'));
    if (safety.dimmingMirror)
        ops.push(...getBulletPoint('Automatisch abblendende Spiegel'));
    if (safety.collisionAvoidance)
        ops.push(...getBulletPoint('Notbremsassistent'));
    if (safety.tcs)
        ops.push(...getBulletPoint('Antriebsschlupfregelung / Traktionskontrolle'));
    ops.push(...getLinebreak());
    /** Comfort */
    ops.push(...getHeadline('Komfortausstattung'));
    if (comfort.electricSideMirrors)
        ops.push(...getBulletPoint('Elektrische Außenspiegel'));
    if (comfort.keylessEntry)
        ops.push(...getBulletPoint('Keyless-Entry'));
    if (comfort.airSuspension)
        ops.push(...getBulletPoint('Luftfahrwerk'));
    if (comfort.centralLocking)
        ops.push(...getBulletPoint('Zentralverriegelung'));
    if (comfort.climatisation === enums_1.EClimatisation.Manual)
        ops.push(...getBulletPoint('Manuelle Klimaanlage'));
    if (comfort.climatisation === enums_1.EClimatisation.Auto)
        ops.push(...getBulletPoint('Automatische Klimaanlage'));
    if (comfort.climatisation === enums_1.EClimatisation.Auto2Zone)
        ops.push(...getBulletPoint('Automatische Klimaanlage (2 Zonen)'));
    if (comfort.climatisation === enums_1.EClimatisation.Auto3Zone)
        ops.push(...getBulletPoint('Automatische Klimaanlage (3 Zonen)'));
    if (comfort.climatisation === enums_1.EClimatisation.Auto4Zone)
        ops.push(...getBulletPoint('Automatische Klimaanlage (4 Zonen)'));
    if (comfort.electricFrontSeats)
        ops.push(...getBulletPoint('Elektrisch verstellbare Vordersitze'));
    if (comfort.heatedFrontSeats)
        ops.push(...getBulletPoint('Beheizbare Vordersitze'));
    if (comfort.electricWindows)
        ops.push(...getBulletPoint('Elektrische Fensterheber'));
    if (comfort.headUpDisplay)
        ops.push(...getBulletPoint('Head-up-Display'));
    if (comfort.panoramicRoof)
        ops.push(...getBulletPoint('Panoramadach'));
    if (comfort.sunroof)
        ops.push(...getBulletPoint('Schiebedach'));
    if (comfort.heatedWindshield)
        ops.push(...getBulletPoint('Beheizbare Windschutzscheibe'));
    if (comfort.heatedSteeringWheel)
        ops.push(...getBulletPoint('Beheizbares Lenkrad'));
    if (comfort.electricTailgate)
        ops.push(...getBulletPoint('Elektrische Heckklappe'));
    if (comfort.leatherSteeringWheel)
        ops.push(...getBulletPoint('Lederlenkrad'));
    if (comfort.lumbarSupport)
        ops.push(...getBulletPoint('Lendenwirbelstütze'));
    if (comfort.massageSeats)
        ops.push(...getBulletPoint('Massagesitze'));
    if (comfort.heatedRearSeats)
        ops.push(...getBulletPoint('Beheizbare Rücksitze'));
    if (comfort.electricRearSeats)
        ops.push(...getBulletPoint('Elektrisch verstellbare Rücksitze'));
    if (comfort.ambientLighting)
        ops.push(...getBulletPoint('Ambientebeleuchtung'));
    if (comfort.foldPassengerSeat)
        ops.push(...getBulletPoint('Umklappbarer Beifahrersitz'));
    if (comfort.ventilatedFrontSeats)
        ops.push(...getBulletPoint('Sitzlüftung'));
    if (comfort.armRest)
        ops.push(...getBulletPoint('Armlehne'));
    if (comfort.bootDivider)
        ops.push(...getBulletPoint('Gepäckraumabtrennung'));
    ops.push(...getLinebreak());
    /** General */
    ops.push(...getHeadline('Sonstige Ausstattung'));
    if (features.allowWheels)
        ops.push(...getBulletPoint('Alufelgen'));
    if (features.roofRails)
        ops.push(...getBulletPoint('Dachreling'));
    if (features.auxHeating)
        ops.push(...getBulletPoint('Standheizung'));
    if (features.summerTires)
        ops.push(...getBulletPoint('Sommerreifen'));
    if (features.winterTires)
        ops.push(...getBulletPoint('Winterreifen'));
    if (features.allSeasonTires)
        ops.push(...getBulletPoint('Ganzjahresreifen'));
    if (features.steelWheels)
        ops.push(...getBulletPoint('Stahlfelgen'));
    if (features.skibag)
        ops.push(...getBulletPoint('Skitasche'));
    if (features.trailerCoupling === enums_1.ETrailerCoupling.DETACHABLE)
        ops.push(...getBulletPoint('Anhängerkupplung (Abnehmbar)'));
    if (features.trailerCoupling === enums_1.ETrailerCoupling.ELECTRIC_SWIVELING)
        ops.push(...getBulletPoint('Anhängerkupplung (Elektronisch schwenkbar)'));
    if (features.trailerCoupling === enums_1.ETrailerCoupling.FIX)
        ops.push(...getBulletPoint('Anhängerkupplung (Starr)'));
    if (features.trailerCoupling === enums_1.ETrailerCoupling.MANUAL_SWIVELING)
        ops.push(...getBulletPoint('Anhängerkupplung (Manuell schwenkbar)'));
    if (features.breakdownKit === enums_1.EBreakdownKit.EMERGENCY_WHEEL)
        ops.push(...getBulletPoint('Notrad'));
    if (features.breakdownKit === enums_1.EBreakdownKit.REPAIR_KIT)
        ops.push(...getBulletPoint('Pannenkit'));
    if (features.breakdownKit === enums_1.EBreakdownKit.SPARE_WHEEL)
        ops.push(...getBulletPoint('Reserverad'));
    ops.push(...getLinebreak());
    /** Custom Options */
    if ((_a = vehicle.modelData.customOptions) === null || _a === void 0 ? void 0 : _a.length) {
        ops.push(...getHeadline('Zusatzausstattung'));
        vehicle.modelData.customOptions.forEach((o) => {
            ops.push(...getBulletPoint(o));
        });
        ops.push(...getLinebreak());
    }
    return ops;
};
exports.getModelDataAsOps = getModelDataAsOps;
const getSeriesOptionsAsOps = (vehicle) => {
    if (!vehicle.vehicleData.features.seriesOptions || !vehicle.vehicleData.features.seriesOptions.length)
        return [];
    const ops = [];
    ops.push(...getHeadline('Serienausstattung (Hersteller)'));
    vehicle.vehicleData.features.seriesOptions.forEach((o) => {
        ops.push(...getBulletPoint(`${o.code}: ${o.description}`));
    });
    ops.push(...getLinebreak());
    return ops;
};
exports.getSeriesOptionsAsOps = getSeriesOptionsAsOps;
const getAdditionalOptionsAsOps = (vehicle) => {
    if (!vehicle.vehicleData.features.additionalOptions || !vehicle.vehicleData.features.additionalOptions.length)
        return [];
    const ops = [];
    ops.push(...getHeadline('Zusatzausstattung (Hersteller)'));
    vehicle.vehicleData.features.additionalOptions.forEach((o) => {
        ops.push(...getBulletPoint(`${o.code}: ${o.description}`));
    });
    ops.push(...getLinebreak());
    return ops;
};
exports.getAdditionalOptionsAsOps = getAdditionalOptionsAsOps;
